import { ELEMENT_TYPE_OPTIONS } from '../../../constants/AssetTestConfig';
import Button from '../../../components/ui/Button';

/**
 * Controlled Start Job form shown before a test session begins.
 *
 * Purely presentational: no state, effects, or store writes — the parent
 * orchestrator owns pre-flight values and handles validation on submit.
 */
export function SessionPreflight({
  workOrder,
  onWorkOrderChange,
  elementType,
  onElementTypeChange,
  preFlightSiteId,
  onSiteChange,
  siteId,
  sites,
  testDate,
  onTestDateChange,
  onSubmit,
}) {
  return (
    <div className="test-session-content test-session-content-preflight">
      <div className="card session-start-card">
        <form
          className="session-start-form"
          onSubmit={(e) => {
            e.preventDefault();
            onSubmit(e);
          }}
        >
          <div className="form-group">
            <label htmlFor="start-work-order">Work Order #</label>
            <input
              id="start-work-order"
              type="text"
              value={workOrder}
              onChange={(e) => onWorkOrderChange(e.target.value)}
              placeholder="e.g. WO-12345"
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="start-element-type">Element Type</label>
            <select
              id="start-element-type"
              value={String(elementType || '')}
              onChange={(e) => onElementTypeChange(e.target.value || '')}
              required
            >
              <option value="">Select element type</option>
              {ELEMENT_TYPE_OPTIONS.map((o) => (
                <option key={o.value} value={o.value}>
                  {o.label}
                </option>
              ))}
            </select>
          </div>
          {!preFlightSiteId && !siteId && (
            <div className="form-group">
              <label htmlFor="start-site">Site</label>
              <select
                id="start-site"
                value={String(preFlightSiteId || '')}
                onChange={(e) => onSiteChange(e.target.value || '')}
              >
                <option value="">Select site</option>
                {sites?.map((s) => (
                  <option key={s.id} value={String(s.id)}>
                    {s.display_name ?? s.name ?? s.site_code ?? 'Unnamed site'}
                  </option>
                ))}
              </select>
            </div>
          )}
          <div className="form-group">
            <label htmlFor="start-test-date">Test Date</label>
            <div className="session-start-date-wrapper">
              <input
                id="start-test-date"
                type="date"
                value={testDate}
                onChange={(e) => onTestDateChange(e.target.value)}
              />
            </div>
          </div>
          <div className="session-start-actions">
            <Button
              type="submit"
              variant="primary"
              className="btn-start-job"
              style={{ touchAction: 'manipulation', WebkitTapHighlightColor: 'transparent' }}
            >
              Start Job
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
